(function () {
  'use strict';

  var TOAST_ID = 'parently-cart-added-toast';
  var PENDING_KEY = 'parently-cart-added-toast-pending';
  var visibleTimer;
  var pendingClearTimer;

  function getToast() {
    return document.getElementById(TOAST_ID);
  }

  function itemMessage(quantity) {
    var count = Number(quantity);
    if (!Number.isFinite(count) || count < 1) count = 1;
    return count === 1 ? 'Item added' : count + ' items added';
  }

  function hideToast() {
    var toast = getToast();
    if (!toast) return;

    toast.classList.remove('is-visible');
    toast.setAttribute('aria-hidden', 'true');
  }

  function showToast(quantity) {
    var toast = getToast();
    if (!toast) return;

    var message = toast.querySelector('[data-cart-toast-message]');
    if (message) message.textContent = itemMessage(quantity);

    toast.classList.add('is-visible');
    toast.setAttribute('aria-hidden', 'false');
    clearTimeout(visibleTimer);
    visibleTimer = setTimeout(function () {
      hideToast();
    }, 4500);
  }

  function savePending(quantity) {
    try {
      var pending = {
        quantity: quantity || 1,
        createdAt: Date.now()
      };
      sessionStorage.setItem(PENDING_KEY, JSON.stringify(pending));
      clearTimeout(pendingClearTimer);
      pendingClearTimer = setTimeout(function () {
        sessionStorage.removeItem(PENDING_KEY);
      }, 10000);
    } catch (error) {
      // Storage can be unavailable in private browsing; the current-page toast still works.
    }
  }

  function showPending() {
    try {
      var raw = sessionStorage.getItem(PENDING_KEY);
      if (!raw) return;

      var pending = JSON.parse(raw);
      sessionStorage.removeItem(PENDING_KEY);
      if (!pending || Date.now() - Number(pending.createdAt) > 15000) return;
      showToast(pending.quantity);
    } catch (error) {
      try {
        sessionStorage.removeItem(PENDING_KEY);
      } catch (storageError) {
        // Ignore storage cleanup failures.
      }
    }
  }

  function installCartAddedListener() {
    window.addEventListener('parently:cart-added', function (event) {
      var detail = event && event.detail ? event.detail : {};
      var quantity = Number(detail.quantity) || 1;
      savePending(quantity);
      showToast(quantity);
    });
  }

  function installCloseButton() {
    var toast = getToast();
    if (!toast) return;

    var close = toast.querySelector('[data-cart-toast-close]');
      if (close) {
        close.addEventListener('click', function () {
          clearTimeout(visibleTimer);
          hideToast();
        });
      }
  }

  var badgeRequest = 0;
  function refreshBadge() {
    if (document.visibilityState === 'hidden' || document.querySelector('cart-items, cart-drawer')) return;
    var request = ++badgeRequest;
    var url = new URL(window.routes.cart_url, window.location.origin);
    url.searchParams.set('sections', 'cart-icon-bubble');
    fetch(url.toString(), { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Cart badge unavailable'); return response.json(); })
      .then(function (sections) {
        if (request !== badgeRequest || !sections['cart-icon-bubble']) return;
        var replacement = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        var icon = document.getElementById('cart-icon-bubble');
        if (icon && replacement) icon.innerHTML = replacement.innerHTML;
      }).catch(function (error) { console.error('Could not refresh the cart badge', error); });
  }
  window.addEventListener('pageshow', function (event) { if (event.persisted) { hideToast(); refreshBadge(); } });
  window.addEventListener('focus', refreshBadge);
  document.addEventListener('visibilitychange', refreshBadge);
  document.addEventListener('cart:refresh', function () { badgeRequest++; });
  window.addEventListener('parently:cart-added', function () { badgeRequest++; refreshBadge(); });

  installCartAddedListener();
  installCloseButton();
  showPending();
})();
